import React from 'react'
import TextField from '../../shared/components/fields/textField/TextField';
import { PropTypes } from 'prop-types';
import ObjectUtils from './../../shared/utils/ObjectUtils';
import backButtonImg from './../../shared/img/back-button.svg'
import { I18n } from 'react-redux-i18n';

const ForgotPassword = ({
    email,
    className,
    handleEmailDataChanged,
    handleCollapseForgotPasswordClicked = () => { },
    handleFieldBlur,
    handleSubmit,
    loading,
    error
}) => {

    const disabled = loading || !ObjectUtils.isNilOrEmpty(email.error) || ObjectUtils.isNilOrEmpty(email.value);

    return <div className={className}>
        <div className="login-form login-password-form" style = {{color:'#919191', paddingTop:'7vh'}}>
            <p style={{fontSize: '1.5rem', fontWeight: '600'}}>{I18n.t('auth.forgotPassword.title')}</p>
            <p style={{paddingTop: '1vh', marginBottom: '7vh', fontSize: '1.1rem'}}>{I18n.t('auth.forgotPassword.instructions')}</p>

            <TextField
                value={email.value}
                label={I18n.t('email')}
                handleFieldChange={value => handleEmailDataChanged(value)}
                handleFieldBlur={() => handleFieldBlur()}
                error={email.error}
                width={12}
            />
            <span className="error-text">
                {error}
            </span>
            <button
                className={ (disabled ? "btn btn-lg btn-outline-secondary" : "btn btn-primary ") + " d-block mx-auto w-50"}
                style={{ fontSize: "1.3em", marginTop:'10vh' }}
                disabled={disabled}
                onClick={handleSubmit}>
                {I18n.t('auth.forgotPassword.button')}
            </button>
            <img 
                className="img-fluid d-block mx-auto"
                style={{marginTop:'6vh', cursor: "pointer"}}
                alt="back"
                src={backButtonImg}
                onClick={() => handleCollapseForgotPasswordClicked(false)}
            />
        </div>
    </div>
}

ForgotPassword.propTypes = {
    email: PropTypes.shape({
        value: PropTypes.string.isRequired,
        error: PropTypes.string
    }),
    handleCollapseForgotPasswordClicked: PropTypes.func,
    handleEmailDataChanged: PropTypes.func.isRequired,
    handleFieldBlur: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool
}

export default ForgotPassword;
